import React from 'react';
import TechniciansPageRoutes from './routes';

import { AuthorizedTemplate } from 'components';

const CustomerPage = () => (
  <AuthorizedTemplate>
    <TechniciansPageRoutes />
  </AuthorizedTemplate>
);

export default CustomerPage;
